export enum DeleteCompany {
  Request = 'DELETE_COMPANY_REQUEST',
  Success = 'DELETE_COMPANY_SUCCESS',
  Failed = 'DELETE_COMPANY_FAILED',
}
